import ContentContainer from "components/ContentContainer";
import { Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container, MainContainer } from "./styles";

const MinimalFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MainContainer>
      <ContentContainer>
        <Container>
          <Text variant="body7" align="center" color="secondary">
            {`© iParque ${new Date().getFullYear()} - ${
              t("6701") /* Todos os direitos reservados */
            }`}
          </Text>
        </Container>
      </ContentContainer>
    </MainContainer>
  );
};

export default MinimalFooter;
